import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import theme from '@/mui/theme';
import styled from '@mui/system/styled';

interface RealizzazioniHeadingProps {
  occhiello?: string;
  title?: string;
  tag?: string;
  info?: {
    label?: string;
    value?: string;
  }[],
}

const StyledOcchiello = styled(Typography)({
  color: "#ff5c04",
  fontSize: "18px",
  fontWeight: "bold",
  letterSpacing: "0",
  lineHeight: "21px",
  margin: "0 0 10px",
});

const StyledTitle = styled(Typography)({
  color: "#ffffff",
  fontSize: "46px",
  fontWeight: "bold",
  letterSpacing: "-0.57px",
  lineHeight: "48px",
  paddingBottom: "25px",
  marginBottom: "15.5px",
  borderBottom: "1px solid #f5f5f5",
  paddingRight: "120px",
});

const StyledTag = styled(Typography)({
  position: "absolute",
  top: "13px",
  right: "0",
  color: "#fff",
  fontSize: "12px",
  fontWeight: "bold",
  letterSpacing: "0",
  lineHeight: "20px",
  textAlign: "center",
  border: "1px solid #fff",
  borderRadius: "5px",
  padding: "3px 18px",
  textTransform: "uppercase",
});

const StyledInfoName = styled(Typography)({
  color: "#fff",
  fontSize: "16px",
  fontWeight: "bold",
  letterSpacing: "0",
  lineHeight: "24px",
  [theme.breakpoints.down('md')]: {
    minWidth: '130px',
  },
});

const StyledInfoValue = styled(Typography)({
  color: "#fff",
  fontSize: "16px",
  letterSpacing: "0",
  lineHeight: "24px",
  marginLeft: "8px",
});

const RealizzazioniHeading: React.FC<RealizzazioniHeadingProps> = ({ occhiello, title, tag, info }) => {
  const { t } = useTranslation('common');
  return <Box sx={{ position: 'relative', pt: '69px', pb: '55px', backgroundColor: '#182641' }}>
    <Container>
      <Grid container rowSpacing={0}>
        <Grid item xs={12}>
          <Box sx={{ position: 'relative' }}>
            {occhiello &&
              <StyledOcchiello mb={2.5}>{occhiello}</StyledOcchiello>
            }
            <Box sx={{ position: 'relative' }}>
              {title &&
                <StyledTitle mb={2.5}>{title}</StyledTitle>
              }
              {tag &&
                <StyledTag mb={2.5}>{tag}</StyledTag>
              }
            </Box>
            {info && info.length > 0 &&
              info.map((element, key) => {
                return (
                  <Box key={key} sx={{display: "inline-flex", marginRight: "35px", marginTop: { md: "0", xs: "10px" }}}>
                    {element.label &&
                      <StyledInfoName>
                        {t(`realizzazioni-${element.label}`, {})}:
                      </StyledInfoName>
                    }
                    {element.value &&
                      <StyledInfoValue>
                        {element.value}
                      </StyledInfoValue>
                    }
                  </Box>
                )
              })
            }
          </Box>
        </Grid>
      </Grid>
    </Container>
  </Box>
}

export default RealizzazioniHeading;
